export {footerFallbackRU} from './footer.fallback';
export {footerFallbackZh} from './footerZh.fallback';
export {footerFallbackEn} from './footerEn.fallback';
